/**
 * @fileoverview > handler for the "/engagement/segments_and_filters_sentence_array/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsAndFiltersSentenceArrayAppGroupIdCacheKeys } from "./constants";
import type {
  PostEngagementSegmentsAndFiltersSentenceArrayAppGroupIdProps,
  EngagementSegmentsAndFiltersSentenceArrayResult,
} from "./types";

export const postEngagementSegmentsAndFiltersSentenceArray = reactQueryMutationAdapter(
  engagementSegmentsAndFiltersSentenceArrayAppGroupIdCacheKeys,
  ({
    appGroupId,
    audiencePayload,
  }: PostEngagementSegmentsAndFiltersSentenceArrayAppGroupIdProps): Promise<EngagementSegmentsAndFiltersSentenceArrayResult> => {
    return fetch(`/engagement/segments_and_filters_sentence_array/${appGroupId}`, "POST", {
      segment_ids: audiencePayload.segmentIds,
      filters: audiencePayload.filters,
    });
  }
);
